import { Component, Input } from '@angular/core';

import { MdBlock, MdListItem, parseMarkdownSubset } from './markdown-subset';

export { MdBlock, MdInline, MdListItem, isSafeHref, parseMarkdownSubset } from './markdown-subset';

/**
 * Renders the restricted CommonMark subset used by the disclosure text.
 *
 * A thin view over `markdown-subset.ts`: all parsing lives there, framework-free, so it can be
 * executed and checked without a test runner this app does not have.
 *
 * The component deliberately produces no HTML string. The template renders the parsed model with
 * ordinary Angular bindings, which escape by construction — so there is no `innerHTML`, no
 * `bypassSecurityTrustHtml`, and nothing to sanitise anywhere in the feature.
 */
@Component({
  selector: 'app-markdown-view',
  templateUrl: './markdown-view.component.html',
  styleUrls: ['./markdown-view.component.css'],
  standalone: false
})
export class MarkdownViewComponent {
  blocks: MdBlock[] = [];

  private _markdown = '';

  @Input()
  set markdown(value: string | null | undefined) {
    this._markdown = value || '';
    this.blocks = parseMarkdownSubset(this._markdown);
  }
  get markdown(): string {
    return this._markdown;
  }

  /** Indentation in em for a nested list item. */
  indentFor(item: MdListItem): string {
    return `${item.indent * 1.2}em`;
  }
}
